import { ITextField, TextField } from 'office-ui-fabric-react';
import React, { useCallback, useMemo } from 'react';
import { Validator } from '../../../../validation';


export const LinkEditor = (props: {
    value?: string;
    onComplete: (url: string) => void;
    onClose: () => void;
}) => {
    const [value, setValue] = React.useState(props.value);
    const inputRef = React.useRef<ITextField | null>(null);

    const focus = useCallback(() => inputRef.current?.focus(), [inputRef]);

    const validator = useMemo(() => Validator.new() /*.required().url()*/.build(), []);

    React.useEffect(focus, []);

    return <TextField className='link-editor'
        value={value}
        componentRef={inputRef}
        onGetErrorMessage={(_: string) => validator.getErrorMessage(_)}
        placeholder='Type URL. Press Enter to Save or Escape to Exit'
        onChange={(e, val) => setValue(val)}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();

                if (validator.isValid(value)) {
                    if (value !== props.value) {
                        props.onComplete(value!);
                    }
                    props.onClose();
                }
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                props.onClose();
            }
        }}
        onBlur={focus} />;
};
